import { useEffect, useRef, useState } from "react"
import { copiarTexto, notify } from "../../utils/utils";

export const DetalleProyecto = ({children,
    nombreBoton,
    alturaDetalle,
    titulo,
    setDespliegue,
    despliegue=false,
}) =>{
    const [ verDetalle, setVerDetalle ] = useState(false);
    const contenidoRef = useRef(null);
    const botonDetalleRef  = useRef(null);

    useEffect(()=> {
        document.addEventListener('mousedown',(event) =>{
            if(
                verDetalle && contenidoRef.current &&
                !contenidoRef.current.contains(event.target) && 
                !botonDetalleRef.current.contains(event.target)
            ){
                despliegue && setDespliegue(false)
                setVerDetalle(false)
            }
        })
    },[verDetalle])

    useEffect(() => {
        if(despliegue){
            setVerDetalle(true)
        }
    },[despliegue])


    return(
        <>
            <div
                key={'contenedorDetalle'}
                className='w-auto h-full flex justify-center'
            >
                <button
                    ref={botonDetalleRef}
                    className={`bg-blue-800 hover:bg-blue-600 rounded-b-[3rem] w-[190px] h-[80%] lg:w-[150px]`}
                    onClick={() => setVerDetalle(!verDetalle)}
                    onAuxClick={() => copiarTexto(titulo)}
                >
                    
                    <label className="font-medium lg:font-normal">{titulo ? titulo : ''}</label>
                    <i className={`fa ${verDetalle ? ' fa-angle-up ': ' fa-angle-down ' } pl-2`}></i>
                </button>
            </div>
            {
                <div
                    key={'contenedorPrincipal'}
                    ref={contenidoRef}
                    className={` top-0 w-full bg-[#0B0C0D] z-50 gap-2  
                        ${verDetalle ? 
                            `lg:h-[400px] lg:max-h-[400px] min-h-0 p-5 lg:p-2 top-0 overflow-visible
                            ${alturaDetalle ? ` h-[${alturaDetalle || '300px' }] max-h-[${alturaDetalle || '300px' }] ` : ' h-[300px] max-h-[300px]'}  ` 
                            : ' max-h-0 h-0 min-h-0 overflow-hidden'
                        }
                        transition-all duration-500 ease-out
                    `}
                >
                    {children}
                </div>
            }
        </>
    )
}